//@flow

import React from 'react'
import { connect } from 'react-redux'

import { selectBlacklist } from '../../../stores/automation/blacklistStore'
import { fetchBlacklistIntoStore } from '../../../sagas/automation/fetchBlacklist'
import { deleteBlacklistUrl } from '../../../sagas/automation/deleteBlacklist'

import { selectCurrentUser } from '../../../stores/currentUser'
import { getSelectedCustomerId } from '../../../stores/ui/selectedCustomer'

import type { BlacklistStore, User, RootState, Dispatch } from '../../../types'

import ColorButton from '../../Controls/ColorButton'

type Props = {
  blacklist: BlacklistStore,
  fetchBlacklistIntoStore: Function,
  deleteBlacklistUrl: Function,
  user: User,
}

class Blacklist extends React.Component<Props> {
  componentWillMount() {
    const { user } = this.props
    this.fetchBlacklistUrls(user)
  }

  fetchBlacklistUrls(user) {
    this.props.fetchBlacklistIntoStore(user.customerId)
  }

  render() {
    const { blacklist, deleteBlacklistUrl } = this.props

    const renderBlacklistItems = items => {
      const rowClasses =
        'bg-white gray h3 f6 ph4 flex items-center bt b--moon-gray hover-bg-near-white'
      if (!items) {
        return <div className={rowClasses}>Loading...</div>
      }
      if (items.length < 1) {
        return (
          <div className={rowClasses}>
            You have not blacklisted any URLs yet.
          </div>
        )
      }
      return items.map(item => {
        return (
          <div className={rowClasses} key={item.id}>
            <span>{item.url}</span>
            <ColorButton
              onClick={() => deleteBlacklistUrl(item.id)}
              className="ml-auto"
              colorClass="gray hover-white"
              backgroundClass="bg-near-white hover-bg-op-brand"
            >
              Remove
            </ColorButton>
          </div>
        )
      })
    }

    return (
      <section className="w-100">
        <div className="bg-op-con-dark white h2 f6 ph4 flex items-center">
          URL
        </div>
        {renderBlacklistItems(blacklist.results)}
      </section>
    )
  }
}

function mapStateToProps(state: RootState) {
  return {
    blacklist: selectBlacklist(state),
    customerId: getSelectedCustomerId(state),
    user: selectCurrentUser(state),
  }
}

function mapDispatchToProps(dispatch: Dispatch) {
  return {
    fetchBlacklistIntoStore(customer) {
      dispatch(fetchBlacklistIntoStore(customer))
    },
    deleteBlacklistUrl(id) {
      dispatch(deleteBlacklistUrl(id))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Blacklist)



// WEBPACK FOOTER //
// ./src/components/Pages/Automation/Blacklist.js